module.exports = __webpack_public_path__ + "img/new_lo_regbackground.3bd8b96f.png";